import { AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useWorkflowValidationStore } from '@/stores/workflow-validation-store';

interface EmptyScopeBannerProps {
  className?: string;
}

export const EmptyScopeBanner = ({ className }: EmptyScopeBannerProps) => {
  const { fieldErrors } = useWorkflowValidationStore();

  const scopeErrors = fieldErrors.filter(
    (e) => e.fieldId === 'collection_scope' || e.fieldId === 'dataset_scope',
  );

  if (scopeErrors.length === 0) return null;

  const hasOldNode = scopeErrors.some(
    (e) => e.fieldName === 'Outdated Tool Node',
  );
  const nodeNames = [...new Set(scopeErrors.map((e) => e.nodeName))].join(', ');

  return (
    <div
      className={cn(
        'flex items-start gap-2 px-3 py-2 rounded-xl shadow-sm max-w-lg',
        'bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800',
        className,
      )}
      data-testid='empty-scope-banner'
    >
      <AlertTriangle className='size-4 text-amber-600 dark:text-amber-400 shrink-0 mt-0.5' />
      <span className='text-sm text-amber-800 dark:text-amber-200'>
        <span className='font-medium'>{nodeNames}</span>
        {hasOldNode
          ? ' needs to be updated. Remove this tool node and re-add it from the catalog to configure which collections the agent can access.'
          : ' has no collections selected. Click the tool node and select which collections the agent should use. If the dropdown is empty, remove this node and re-add it from the catalog.'}
      </span>
    </div>
  );
};
